/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Identifying_SpeakersInputs */



/**
* | output |
* | --- |
* | "Identifying Speakers..." |
*
* @param {Identifying_SpeakersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const identifying_speakers = /** @type {((inputs?: Identifying_SpeakersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Identifying_SpeakersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Identification des intervenants...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sprecher identifizieren...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Identificazione dei relatori...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Идентификация говорящих...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Identificando a los hablantes...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("识别说话人……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("話者を識別しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वक्ताओं की पहचान करना...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Identificando os palestrantes...")
	return /** @type {LocalizedString} */ ("Identifying Speakers...")
});